// Client half of enterprise module gating. The login response carries a moduleAccess
// object ({ availableModules, defaultLandingModule }) persisted under localStorage
// "module_access". Nav links for disabled modules are removed entirely (never shown
// disabled), login lands on the resolved route, and the router guard bounces direct
// navigation to a disabled module. Server-side enforcement is tools.requireModule.
// CommonJS on purpose so tests/ can require it directly (see buttonHoverTheme.js).

const MODULE_ROUTES = {
    cases: '/Cases',
    crimeSearch: '/singleSearch',
    creditCalculator: '/creditCalculator',
};

const MODULE_ORDER = ['cases', 'crimeSearch', 'creditCalculator'];

const STORAGE_KEY = 'module_access';

function normalizeAvailableModules(raw) {
    let value = raw;
    if (typeof value === 'string') {
        try {
            value = JSON.parse(value);
        } catch (e) {
            return null;
        }
    }
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return null;
    }
    return value;
}

function isModuleEnabled(availableModules, moduleName) {
    return normalizeAvailableModules(availableModules)?.[moduleName] !== false;
}

function moduleForPath(path) {
    const lower = (path || '').toLowerCase();
    for (const [moduleName, route] of Object.entries(MODULE_ROUTES)) {
        const routeLower = route.toLowerCase();
        if (lower === routeLower || lower.startsWith(routeLower + '/')) {
            return moduleName;
        }
    }
    return null;
}

function resolveLandingRoute(moduleAccess) {
    const availableModules = normalizeAvailableModules(moduleAccess?.availableModules);
    const preferred = moduleAccess?.defaultLandingModule;
    if (preferred && MODULE_ROUTES[preferred] && isModuleEnabled(availableModules, preferred)) {
        return MODULE_ROUTES[preferred];
    }
    for (const moduleName of MODULE_ORDER) {
        if (isModuleEnabled(availableModules, moduleName)) {
            return MODULE_ROUTES[moduleName];
        }
    }
    // Everything disabled is a misconfiguration; land on the default and let the
    // server's 403 tell the story rather than trapping navigation in a loop.
    return MODULE_ROUTES.cases;
}

function getStoredModuleAccess(storage = typeof localStorage !== 'undefined' ? localStorage : undefined) {
    const raw = storage?.getItem?.(STORAGE_KEY);
    if (!raw) {
        return null;
    }
    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
        return null;
    }
}

function storeModuleAccess(moduleAccess, storage = typeof localStorage !== 'undefined' ? localStorage : undefined) {
    storage?.setItem?.(STORAGE_KEY, JSON.stringify(moduleAccess ?? null));
}

module.exports = {
    MODULE_ROUTES,
    MODULE_ORDER,
    STORAGE_KEY,
    normalizeAvailableModules,
    isModuleEnabled,
    moduleForPath,
    resolveLandingRoute,
    getStoredModuleAccess,
    storeModuleAccess,
};
